import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { notifySomething } from "../_Utils/AppDocuCommon";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";
import PacketDialogForm from "./_PacketDialogForm";

export default class AddPacketDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: AddPacketDialog.getInitialItemData(),
    };
  }

  static getInitialItemData() {
    return {
      name: '',
      description: '',
      ecu_type: '',
      kit_code: '',
      rail_code: '',
      rail2_code: '',
      other_accessories: '',
      status: '',
    };
  }

  addPackageService = async (itemData) => {
    try {
      const res = await AppDocuServiceCall.createPacket(itemData);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error adding package', 'error');
        return;
      }
      await this.props.onItemsChange(); // Refresh the packages list after adding !!!
      this.props.onClose(); // Close the dialog after adding !!!
    } catch (error) {
      console.error('Error adding package:', error);
      notifySomething('Error adding package', 'error');
    }
  };
    
  handleAdd = async () => {
    const m = this.state.itemData || {};
    const data = {
      ...m,
      name: m.name || '',
      description: m.description || '',
      ecu_type: m.ecu_type || '',
      kit_code: m.kit_code || '',
      rail_code: m.rail_code || '',
      rail2_code: m.rail2_code || '',
      other_accessories: m.other_accessories || '',
      status: m.status || '',
    };
    // Call the service to add the package
    await this.addPackageService(data)
  };

  componentDidUpdate(prevProps) {
    // Reset fields when dialog is opened
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ itemData: AddPacketDialog.getInitialItemData() });
    }
  }

  render() {
    return (
      <Dialog open={!!this.props.isOpen} onClose={this.props.onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Add New Packet</DialogTitle>
        <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
          <PacketDialogForm
            itemData={this.state.itemData}
            onChange={newData => this.setState({ itemData: newData })}
            disabled={false}
            packageCodes={this.props.packageCodes}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button onClick={this.handleAdd} color="primary">Add</Button>
        </DialogActions>
      </Dialog>
    );
  }
}
